import { render, staticRenderFns } from "./SelesaiMagang.vue?vue&type=template&id=3857e202&scoped=true"
import script from "./SelesaiMagang.vue?vue&type=script&lang=js"
export * from "./SelesaiMagang.vue?vue&type=script&lang=js"
import style0 from "./SelesaiMagang.vue?vue&type=style&index=0&id=3857e202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3857e202",
  null
  
)

export default component.exports